const remotes = require(`./remotes/${process.env.NODE_ENV}_remotes`);
module.exports = {
  name:'base',
  buildName:'base',
  port:9101,
  remotes
}
